<div class="box"
[ngClass]="{
  'selected': selected
}">
  <img src="./assets/svgs/{{ icon }}.svg" alt="{{ icon }}">
  <p [class]="titleColor">
    {{ title }}
  </p>
</div>
  